import { FocusNode } from '@please/lrud'
import styled, { css } from 'styled-components'

import {
  CounterElem,
  VideoCountdownWrapper,
} from '@/components/CountdownEvent/styles'
import { IconButtonElem } from '@/components/IconButton/styles'

export const VideoPlayerLabel = styled.div<{ $bgcolor: string }>`
  position: absolute;
  top: 1rem;
  left: 1rem;
  font-size: 1.4rem;
  line-height: 1.5em;
  background-color: ${({ $bgcolor }) => $bgcolor};
  color: black;
  z-index: 10;
  padding: 0 1rem;
  border-radius: 1rem;
`

export const VideoElement = styled.video`
  position: absolute;
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9;
  background: ${(props) => props.theme.colors.player.background};
`

export const Preloader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const LogoPreloader = styled.div<{
  $src?: string
  $isBlocked?: boolean
}>`
  position: relative;
  display: flex;
  max-width: ${({ $isBlocked }) => ($isBlocked ? '15%' : '50%')};
  height: ${({ $isBlocked }) => ($isBlocked ? '15%' : '50%')};
  justify-content: center;
  align-items: center;
  /* mask-image: ${(props) =>
    props.$isBlocked ? 'none' : `url(${props.$src})`}; */
  /* -webkit-mask-image: ${(props) =>
    props.$isBlocked ? 'none' : `url(${props.$src})`}; */
  & img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  ${({ $isBlocked }) =>
    $isBlocked &&
    css`
      position: absolute;
      top: 4%;
      left: 4%;
    `}
  ${({ $isBlocked }) =>
    !$isBlocked &&
    css`
      /* mask-repeat: no-repeat; */
      /* -webkit-mask-repeat: no-repeat; */
      /* mask-position: 50% 50%; */
      /* -webkit-mask-position: 50% 50%; */
      /* mask-size: 100% auto; */
      /* -webkit-mask-size: 100% auto; */
      &:after {
        display: none;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        animation: logoPreloader 3s infinite;
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.1) 15%,
          rgba(255, 255, 255, 0.3) 30%,
          rgba(255, 255, 255, 0.9) 50%,
          rgba(255, 255, 255, 0.3) 70%,
          rgba(255, 255, 255, 0.1) 85%,
          rgba(255, 255, 255, 0) 100%
        );
      }
      & img {
        opacity: 0.4;
      }
    `}
`

export const StyledControlsContainer = styled.div<{
  $inFront: boolean
  $domRect?: DOMRect
  $isFullscreen?: boolean
}>`
  position: absolute;
  top: 0;
  left: 0;
  /* top: ${(props) => props.$domRect?.top || '0'}px;
  bottom: ${(props) => props.$domRect?.bottom || '0'}px;
  left: ${(props) => props.$domRect?.left || '0'}px;
  right: ${(props) => props.$domRect?.right || '0'}px; */
  width: ${(props) =>
    props.$domRect
      ? props.$domRect?.width + 'px'
      : props.$isFullscreen
      ? '100vw'
      : ''};
  height: ${(props) =>
    props.$domRect
      ? props.$domRect?.height + 'px'
      : props.$isFullscreen
      ? '100vh'
      : ''};
  ${(props) => props.$inFront && `z-index: 1;`}/* x: ${(props) =>
    props.$domRect?.x || ''}px;
  y: ${(props) => props.$domRect?.y || ''}px; */
`
export const BlockedOverlayContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
`
export const ControlsContainer = styled(FocusNode)<{
  $padding?: string
  $transparent?: boolean
}>`
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: hidden;
  background: ${({ theme, $transparent }) =>
    $transparent
      ? 'transparent'
      : `linear-gradient(to top, ${theme.colors.player.controlsBg} 0%, rgba(0,0,0,0) 40%, rgba(0,0,0,0) 70%, ${theme.colors.player.controlsBg} 100%)`};
  /* pointer-events: none; */
  padding: ${({ $padding }) => $padding || '6% 6% 1.5% 6%'};
  display: flex;
  button {
    pointer-events: auto;
  }
`

export const VideoBackground = styled.div`
  height: 100vh;
  width: 100%;
  background-color: ${(props) => props.theme.colors.player.background};
`

export const PlayImage = styled.img`
  height: 40px;
  width: 40px;
`
export const FocusButtonNode = styled(FocusNode)`
  margin-right: 10px;
  padding: 4px;
  width: 40px;
  border-radius: 8px;
  &.isFocusedLeaf {
    border: 0 !important;
    box-shadow: inset 0 0 0 1px
        ${(props) => props.theme.colors.player.focusedElem.border},
      0 0 0 1px ${(props) => props.theme.colors.player.focusedElem.border};
  }
`
export const BlockedBgImage = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  opacity: 0;
  &.isVisible {
    opacity: 1;
    transition: all 0.2s ease-out;
  }
`

export const AdProgressionCounter = styled.div`
  align-self: baseline;
  padding: 18px 24px;
  border-radius: 32px;
  font-size: 24px;
  line-height: 1.18;
  background-color: rgba(255, 255, 255, 0.2);

  > span {
    color: #fff;
    text-transform: uppercase;
    margin-right: 12px;
  }
`

export const Dot = styled.div`
  display: inline-block;
  margin: 8px 8px 4px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: #fff;
`

export const BackBox = styled.div`
  display: flex;
  margin-top: 20px;
  align-items: center;
  ${IconButtonElem} {
    margin-right: 20px;
    width: 40px;
    height: 40px;
    opacity: 1;
  }
`

export const AnimationBox = styled.div<{
  $isExiting?: boolean
  $justifyContent?: string
  $height?: string
  $alignSelf?: string
  $showDiv: boolean
  $hidden?: boolean
}>`
  @keyframes inAnimation {
    0% {
      opacity: 0;
      transform: translateY(200px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes outAnimation {
    0% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(200px);
    }
  }

  animation: ${(props) => (props.$isExiting ? 'outAnimation' : 'inAnimation')}
    450ms ease-out;

  display: ${({ $showDiv }) => ($showDiv ? 'flex' : 'none')};
  flex-direction: column;
  width: 100%;
  justify-content: ${({ $justifyContent }) => $justifyContent || 'flex-start'};
  height: ${({ $height }) => $height || 'auto'};
  align-self: ${({ $alignSelf }) => $alignSelf || 'auto'};

  ${({ $hidden }) =>
    $hidden &&
    css`
      animation: none;
      display: none;
    `}
`

export const Box = styled.div<{
  $display?: string
  $justifyContent?: string
  $height?: string
  $width?: string
  $alignSelf?: string
  $alignItems?: string
  $flexDirection?: string
  $marginY?: number
  $marginX?: number
  $marginTop?: number
  $marginRight?: number
  $marginBottom?: number
  $marginLeft?: number
}>`
  display: ${({ $display }) => $display || 'flex'};
  flex-direction: ${({ $flexDirection }) => $flexDirection || 'row'};
  justify-content: ${({ $justifyContent }) => $justifyContent || 'flex-start'};
  height: ${({ $height }) => $height || 'auto'};
  width: ${({ $width }) => $width || 'auto'};
  align-self: ${({ $alignSelf }) => $alignSelf || 'auto'};
  align-items: ${({ $alignItems }) => $alignItems || 'normal'};
  margin-top: ${({ $marginTop = 0 }) => `${$marginTop}px`};
  margin-right: ${({ $marginRight = 0 }) => `${$marginRight}px`};
  margin-bottom: ${({ $marginBottom = 0 }) => `${$marginBottom}px`};
  margin-left: ${({ $marginLeft = 0 }) => `${$marginLeft}px`};
`
export const ButtonsBox = styled.div<{ $height: number }>`
  position: absolute;
  left: 12%;
  bottom: 10%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: ${({ $height }) => `${$height}px`};
  width: 450px;
  z-index: 1;
`
export const ShowChannelsButton = styled(FocusNode)`
  & img {
    height: 40px;
    width: 40px;
    border-radius: 8px;
    overflow: hidden;
  }
  &.isFocusedLeaf img {
    border: 0 !important;
    box-shadow: inset 0 0 0 1px #fff,
      0 0 0 1px ${(props) => props.theme.colors.player.focusedElem.border};
  }
`
export const HideChannelsButton = styled(FocusNode)`
  & img {
    height: 40px;
    width: 40px;
    border-radius: 8px;
    overflow: hidden;
  }
  &.isFocusedLeaf img {
    border: 0 !important;
    box-shadow: inset 0 0 0 1px #fff,
      0 0 0 1px ${(props) => props.theme.colors.player.focusedElem.border};
  }
`

export const VideoError = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.3);
  top: 25px;
  left: 25px;
  width: calc(100% - 50px);
  height: calc(100% - 50px);
  border-radius: 24px;
  overflow: hidden;
`

export const AdContainerEl = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  //pointer-events: all;
  //transform: scale(0.5);
  //transform-origin: 50% 50%;
  //border: 4px solid red;
  //opacity: 0.5;
`
export const VideoEndedOverlayTitle = styled.div`
  font-size: 40px;
  line-height: 1.4;
  font-weight: 700;
  text-align: center;
  margin: 24px;
`
export const VideoEndedOverlayNote = styled.div`
  font-size: 24px;
  line-height: 1.4;
  font-weight: 400;
  text-align: center;
  margin: 0 24px 24px;
`

export const VideoEndedOverlayContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`
export const BlockedOverlayWrapper = styled.div<{
  $hasFreeVideo: boolean
  $isStageHome: boolean
}>`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ $hasFreeVideo, theme }) =>
    $hasFreeVideo ? 'none' : theme.colors.player.background};
  z-index: ${({ $isStageHome }) => ($isStageHome ? '1' : '0')};
`
export const VideoEndedOverlayContainer = styled.div<{
  $isFullscreen: boolean
  $isStageHome: boolean
}>`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
    108deg,
    ${(props) => props.theme.colors.dialogPopup.background.start} 0%,
    ${(props) => props.theme.colors.dialogPopup.background.end} 100%
  );

  padding: ${({ $isStageHome }) =>
    $isStageHome ? '240px 200px 440px 340px' : '50px'};

  ${({ $isFullscreen }) =>
    $isFullscreen &&
    css`
      ${VideoEndedOverlayTitle} {
        font-size: 64px;
      }
      ${VideoEndedOverlayNote} {
        font-size: 32px;
        margin: 24px;
      }
      ${VideoCountdownWrapper} {
        font-size: 120px;
      }
      ${CounterElem} {
        flex: 0 0 190px;
      }
      padding: 120px 80px 80px;
      z-index: 12;
    `}
`
export const ActionWrapper = styled(FocusNode)`
  display: flex;
  height: 70px;
  justify-content: center;
  margin-top: 120px;
`
export const CountdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`
